import Date from '../date/Date';
import Department from './Department';
import Sport from './offering/Sport';

export default class TrainerLicense {
    constructor(employeeId) {
        this.id = null;
        this.level = null;
        this.name = '';
        this.department = null;
        this.delivered = Date.today();
        this.validUntil = null;
        this.employeeId = employeeId;
        this.sportType = null;

        this.invalid = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let trainerLicense = new TrainerLicense(data.employeeId);

        trainerLicense.id = data.id;
        trainerLicense.level = data.level;
        trainerLicense.name = data.name;
        trainerLicense.department = data.department ? Department.fromData(data.department) : null;
        trainerLicense.delivered = data.delivered !== null ? Date.fromIso8601(data.delivered) : Date.today();
        trainerLicense.validUntil = data.validUntil  !== null ? Date.fromIso8601(data.validUntil) : null;
        trainerLicense.sportType = Sport.fromData(data.sportType);

        trainerLicense.invalid = false;

        Object.seal();

        return trainerLicense;
    }

    toData() {
        return {
            id: this.id,
            level: this.level,
            name: this.name,
            departmentId: this.department !== null ? this.department.id : null,
            employeeId: this.employeeId,
            delivered: this.delivered !== null ? this.delivered.toIso8601() : null,
            validUntil: this.validUntil !== null ? this.validUntil.toIso8601() : null,
            sportTypeId: this.sportType !== null ? this.sportType.id : null,

            invalid: this.invalid,
        };
    }

    isEmptyName() {
        return !this.name;
    }

    isEmptyLevel() {
        return !this.level;
    }
}
